<ng-container *transloco="let t; prefix: 'organizations.detailPage.riskAnalysisDeliveryTab.reminderTrackerStatus'">
  <nz-tag
    class="reminder-tracker-status {{ statusClass() }}"
    [nz-tooltip]="
      showDateTooltip()
        ? t('tooltip', { date: (reminderTrackerUpdatedAt() | localizedDate: dateTimeFormat) })
        : tooltipKey()
          ? t(tooltipKey()!)
          : null
    "
  >
    <span class="reminder-tracker-status__label">{{ t('label') }}:</span>
    <span class="reminder-tracker-status__value">{{ t(statusLabelKey()) }}</span>
    @if (showCreatedAt()) {
      <span class="reminder-tracker-status__separator" aria-hidden="true">·</span>
      <span class="reminder-tracker-status__created-label">{{ t('createdOn') }}</span>
      <span class="reminder-tracker-status__date">{{
        reminderTrackerCreatedAt() | localizedDate: dateTimeFormat
      }}</span>
    }
    @if (completedAt()) {
      <span class="reminder-tracker-status__separator" aria-hidden="true">·</span>
      <span class="reminder-tracker-status__completed-label">{{ t('completedOn') }}</span>
      <span class="reminder-tracker-status__date">{{ completedAt() | localizedDate: dateTimeFormat }}</span>
    }
  </nz-tag>

  @if (nextReminderAt()) {
    <nz-tag
      class="reminder-tracker-next"
      [nz-tooltip]="t('nextReminderTooltip', { date: (nextReminderAt() | localizedDate: dateFormat) })"
    >
      <span class="reminder-tracker-next__label">{{ t('nextReminderOn') }}</span>
      <span class="reminder-tracker-next__date">{{ nextReminderAt() | localizedDate: dateFormat }}</span>
    </nz-tag>
  }
</ng-container>
